import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Col, Form, Row, FormGroup, Label, Input, } from 'reactstrap';
import { AiFillPrinter } from 'react-icons/ai'; //GoIssueClosed

const ModalsComentario = (props) => {
   
    
    console.log(props)


    const {
        buttonLabel,
        className, informativo
    } = props;

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    const update = (e) => {
        console.log(props.state.EstadoModal);
        console.log(e.target.value);
      //  this.setState({ [e.target.name]: e.target.value });
        //console.log(props)
        props.onUpdate(e.target.value);
      
    };



    const EstadoSolicitud = (e) => {

        props.onUpdateEstadoFail(e.target.value);
            console.log(props.state.EstadoModal);
            //props.state.EstadoModal = e.target.value

            console.log(props.state.EstadoModal);

            toggle()

        
           
    }

    const EstadoSolicitudValidado = (e) => {
    

        if (document.getElementById("adjunto3") !== null) {
            if (document.getElementById("imagenFirmaGet").src !== "" && document.getElementById("adjunto6") !== null) {
                props.onUpdateEstadoFail("EN REVISIÓN FIRMA Y SELFIE");
              
              
                toggle()

            } else {

                LLamarModal("La firma y la selfie son requeridos")
            }
        } else {
            LLamarModal("La Carátula estado de cuenta es obligatoria")

        }
       

    }

    const EstadoSolicitudAnexarContrato = (e) => {
        

        if (document.getElementById("adjunto5") !== null) {
        
            props.onUpdateEstadoFail(e.target.value);

                console.log(props.state.EstadoModal);
               // props.state.EstadoModal = e.target.value

                console.log(props.state.EstadoModal);

                toggle()

           
        } else {
            LLamarModal("El contrato es obligatorio para poder continuar.")

        }


    }

    const LLamarModal = (mensaje) => {
        props.LLamarModal(mensaje);
    }


    const ActualizarElemento = () =>{
     
        props.onActualizar(props, props.state.EstadoModal)
        setModal(!modal);
    }

    const Imprimir = () => {

        window.print();
    }


    if (props.state.Rol == "Admin") {
        //4 botones
        if (props.state.Estado == "ENVIADA") {
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>

                        <Col sm={2} xs={3}>
                           <Button color="warning" className="btnFull" onClick={EstadoSolicitud} value="INCOMPLETA">Incompleta</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="success" className="btnFull" onClick={EstadoSolicitud} value="EN REVISIÓN">En Revisión</Button>
                        </Col>

                      
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>


                      
                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                         
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else if (props.state.Estado == "APROBADA") {
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                      
                        <Col sm={2} xs={3}>
                            <Button color="danger" className="btnFull" onClick={EstadoSolicitud} value="RECHAZAR SOLICITUD">Rechazar solicitud</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="success" className="btnFull" onClick={EstadoSolicitud} value="DISPERSADO">Dispersar</Button>
                        </Col>
                       

                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>

                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                         
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else if (props.state.Estado == "EN REVISIÓN") {
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">

                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>

                        <Col sm={2} xs={3}>
                            <Button color="warning" className="btnFull"  onClick={EstadoSolicitud} value="REQUIERE CAMBIOS">Requiere cambios</Button>
                        </Col>

                        <Col sm={2} xs={3}>
                            <Button color="danger" className="btnFull"  onClick={EstadoSolicitud} value="RECHAZAR SOLICITUD">Rechazar solicitud</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="success" className="btnFull"  onClick={EstadoSolicitudAnexarContrato} value="CONTRATO ANEXADO">Anexar Contrato</Button>
                        </Col>
                        
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>
                    
                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                          Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                         
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else if (props.state.Estado == "EN REVISIÓN FIRMA Y SELFIE") {
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                        <Col sm={4} xs={3}>
                            <Button color="warning" className="btnFull" onClick={EstadoSolicitud} value="REQUIERE CAMBIOS EN FIRMA O SELFIE">Requiere cambios en firma o selfie</Button>
                        </Col>

                        <Col sm={2} xs={3}>
                            <Button color="danger" className="btnFull" onClick={EstadoSolicitud} value="RECHAZAR SOLICITUD">Rechazar solicitud</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="success" className="btnFull" onClick={EstadoSolicitud} value="APROBADA">Aprobar</Button>
                        </Col>

                     
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>


                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                        
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else if (props.state.Estado == 'RECHAZAR SOLICITUD') {
            //solo regresar
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                       
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                           
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>

                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        
                    
                        </ModalBody>
                        <ModalFooter>
                        
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else {
      
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull"  onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="danger" className="btnFull"  onClick={EstadoSolicitud} value="RECHAZAR SOLICITUD">Rechazar solicitud</Button>
                        </Col>
                 
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>
                       
                      
                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                            
                        </ModalFooter>
                    </Modal>
                </div>
            );

        }
    }
    else if (props.state.Rol == "Vendedor") {
        //4 botones
        console.log(props.state)
        if (props.state.Estado == "ENVIADA") {
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>

                        <Col sm={2} xs={3}>
                            <Button color="warning" className="btnFull" onClick={EstadoSolicitud} value="INCOMPLETA">Incompleta</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="success" className="btnFull" onClick={EstadoSolicitud} value="EN REVISIÓN">En Revisión</Button>
                        </Col>
                       
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>
                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                         
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else if (props.state.Estado == "APROBADA") {
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                        
                     
                        <Col sm={2} xs={3}>
                            <Button color="success" className="btnFull" onClick={EstadoSolicitud} value="DISPERSADO">Dispersar</Button>
                        </Col>
                       
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>


                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
     
        else {

            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">

                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="danger" className="btnFull" onClick={EstadoSolicitud} value="RECHAZAR SOLICITUD">Rechazar solicitud</Button>
                        </Col>
                  
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>

                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                           
                        </ModalFooter>
                    </Modal>
                </div>
            );

        }
    }
    else if (props.state.Rol == "Analista de Crédito") {
        //4 botones
        console.log(props.state)
        if (props.state.Estado == "EN REVISIÓN") {
            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>

                        <Col sm={2} xs={3}>
                            <Button color="warning" className="btnFull" onClick={EstadoSolicitud} value="REQUIERE CAMBIOS">Requiere cambios</Button>
                        </Col>

                        <Col sm={2} xs={3}>
                            <Button color="danger" className="btnFull" onClick={EstadoSolicitud} value="RECHAZAR SOLICITUD">Rechazar solicitud</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="success" className="btnFull" onClick={EstadoSolicitudAnexarContrato} value="CONTRATO ANEXADO">Anexar Contrato</Button>
                        </Col>
                      
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>

                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                           
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else if (props.state.Estado == "EN REVISIÓN FIRMA Y SELFIE") {
            return (
                <div>
                    <FormGroup row>
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                        <Col sm={4} xs={3}>
                            <Button color="warning" className="btnFull" onClick={EstadoSolicitud} value="REQUIERE CAMBIOS EN FIRMA O SELFIE">Requiere cambios en firma o selfie</Button>
                        </Col>
                       
                        <Col sm={3} xs={3}>
                            <Button color="danger" className="btnFull" onClick={EstadoSolicitud} value="RECHAZAR SOLICITUD">Rechazar solicitud</Button>
                        </Col>
                        <Col sm={2} xs={3}>
                            <Button color="success" className="btnFull" onClick={EstadoSolicitud} value="APROBADA">Aprobar</Button>
                        </Col>
                       
                        </Col>
                        <Col sm={1} xs={1}>
                            <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                            </Col>
                        </Col>
                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                          
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else {

            return (
                <div>
                    <FormGroup row>
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={4} xs={12}>
                        </Col >

                        <Col sm={2} xs={3}>
                            <Button color="info" className="btnFull" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                        <Col sm={3} xs={3}>
                            <Button color="danger" className="btnFull" onClick={EstadoSolicitud} value="RECHAZAR SOLICITUD">Rechazar solicitud</Button>
                        </Col>

                </Col>
                    <Col sm={1} xs={1}>
                        <Col sm={6} xs={12}>
                            <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                        </Col>
                    </Col>
                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}

                        </ModalFooter>
                    </Modal>
                </div>
            );

        }
    }
    else {

                                                                        
        if (props.state.Estado == "CONTRATO ANEXADO" || props.state.Estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {

            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={10} xs={10} className="justify-content-md-center row ">
                        <Col sm={2} xs={3}>
                            <Button className="btnFull" color="info" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>
                        <Col sm={3} xs={4}>
                                <Button className="btnFull" color="success" onClick={EstadoSolicitudValidado} value="EN REVISIÓN FIRMA Y SELFIE">Enviar firma y selfie</Button>
                            </Col>
                        </Col>  
                        <Col sm={1} xs={1}>
                        <Col sm={6} xs={12}>
                                <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                        </Col>  
                        </Col>  
                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                            Si lo desea puede ingresar un comentario.
                    <Input type="textarea" onChange={update} name="ComentarioModals" placeholder="Opcional" rows={5} />
                        </ModalBody>
                        <ModalFooter>
                       
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                            <Button color="primary" onClick={ActualizarElemento}>Aceptar</Button>{' '}
                        </ModalFooter>
                    </Modal>
                </div>
            );

        }
    
        else {
            //solo regresar

            return (
                <div>
                    <FormGroup row className="justify-content-md-center">
                        <Col sm={11} xs={11}>
                        <Col sm={2} xs={3}>
                            <Button className="btnFull"  color="info" onClick={() => props.cancelarPantalla()}>Regresar</Button>
                        </Col>

                     
                        </Col>
                    <Col sm={1} xs={1}>
                        <Col sm={6} xs={12}>
                            <a className='Imprimir' onClick={Imprimir}><AiFillPrinter /></a>
                        </Col>
                    </Col>  
                    </FormGroup>

                    <Modal isOpen={modal} className={className}>
                        <ModalHeader >Confirmar</ModalHeader>
                        <ModalBody>
                        
                        </ModalBody>
                        <ModalFooter>
                         
                            <Button color="secondary" onClick={toggle} >Regresar</Button>
                    
                        </ModalFooter>
                    </Modal>
                </div>
            );

        }
       
    }
}

export default ModalsComentario;